import { render } from "./KaiJgg.vue?vue&type=template&id=3a477d0a&scoped=true"
import script from "./KaiJgg.vue?vue&type=script&lang=js"
export * from "./KaiJgg.vue?vue&type=script&lang=js"

import "./KaiJgg.vue?vue&type=style&index=0&id=3a477d0a&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1e77ff55b92932984816aac78a22ff52/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a477d0a"]])

export default __exports__